import { RequestPlugins, SupportedPlugins } from 'gatsby-theme-oss-docs';
import React from 'react';
export default {
  RequestPlugins,
  SupportedPlugins,
  React
};